<template>
    <div>
        <block v-if="loading" />
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
                <v-btn small class="btn-save mr-1" @click="printconfig">
                    <v-icon>
                        mdi-printer
                    </v-icon>
                </v-btn>
                <v-btn small class="btn-save mr-1" @click="getReportSales">
                    <v-icon>
                        mdi-magnify
                    </v-icon>

                </v-btn>
            </div>
        </v-card>
        <v-row class="mt-4">
            <v-col cols="12" md="6">
                <v-select v-model="search.month" :items="monthList" item-text="MES" item-value="monthIndex" label="Mes"
                    outlined attach dense @change="getReportSales"></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-select v-model="search.year" :items="yearLIst" item-text="AÑO" item-value="AÑO" label="Año" outlined
                    attach dense @change="getmonths"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-radio-group v-model="reportType" row>

                    <v-radio label="Contribuyentes" value="1"></v-radio>
                    <v-radio label="Consumidores Finales" value="2"></v-radio>

                </v-radio-group>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="dataType">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <hr/>
        <br/>
        <v-row>
            <v-col cols="12" md="6">
                <v-radio-group v-model="printType" row>
                    <v-radio label="Ver formato csv" value="1"></v-radio>
                    <v-radio label="Ver oficial hacienda" value="2"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12" md="2">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-alert
                            v-bind="attrs"
                            v-on="on"
                            v-show="invalidRowsCount > 0"
                            type="warning"
                            dense
                            outlined
                            @click="getAlerts()"
                            style="cursor: pointer;"
                        >
                            Errores: {{ invalidRowsCount }}
                        </v-alert>
                    </template>

                    <span>
                        Se encontraron {{ invalidRowsCount }} comprobantes sin clasificacion. Se recomienda corregirlos antes de descargar el anexo.
                    </span>
                </v-tooltip>
            </v-col>
            <v-col cols="12" md="4">
                
                <div class="d-flex justify-md-end">
                    <v-checkbox
                        v-model="allBranch"
                        label="Integrar datos de sucursales"
                        ref="integrateBrachCheckbox"
                    ></v-checkbox>
                </div>
            </v-col>
        </v-row>
        <template v-if="printType == '1'">
            <GeneralFilter v-if="reportType == '1'" :filterEndpoint="$API.accountingreports.getSearchSalesByDate"
                :search="{ ...search, reportType, dataType, allBranch }" @emptyFilter="getReportSales" @filtered="filterHandler">
                <DxDataGrid 
                    v-if="reportType == '1'" 
                    :dataSource="DataTable" 
                    @row-prepared="onRowPrepared"
                    @exporting="onExporting"
                    :word-wrap-enabled="true" 
                    :column-auto-width="true" 
                    :scrolling="{ useNative: true }" 
                    :key="`csv-taxpayer-${reportType}-${printType}`"
                    >
                    <DxColumn
                        caption="Acciones"
                        cell-template="actionTemplate"
                        :width="80"
                        :allow-exporting="false"
                        :fixed="true"
                        fixed-position="left"
                    />
                    <template #actionTemplate="{ data }">
                        <v-btn
                            @click="openEditDialog(data.data)"
                            title="Editar clasificación"
                            icon
                            x-small
                        >
                            <v-icon :color="hasEmptyRequiredFields(data.data) ? 'orange': 'green'">mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <DxColumn
                        v-for="col in columnsTaxPayer"
                        :key="col.dataField"
                        :data-field="col.dataField"
                        :caption="col.caption"
                        :visible="col.visible !== false"
                    />
                    <DxExport :enabled="true" />
                    <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                    <DxPaging defaultPageSize="5" />
                </DxDataGrid>
            </GeneralFilter>
            <DxDataGrid 
                v-if="reportType === '2'" 
                :dataSource="DataTable2" 
                :columns="columnsFinalCustomer" @exporting="onExporting"
                :word-wrap-enabled="true" 
                :column-auto-width="true" 
                :scrolling="{ useNative: true }" 
                :key="`csv-taxpayer-${reportType}-${printType}`"
                >
                <DxExport :enabled="true" />
                <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                <DxPaging defaultPageSize="5" />
            </DxDataGrid>
        </template>
        <template v-else>
            <v-row>
                <v-col cols="12" md="2">
                    <v-btn class="btn-save" @click="onExportingToPdf()">Imprimir formato oficial</v-btn>
                </v-col>
                <v-col cols="12" md="2">
                    <v-btn class="btn-save" @click="onExportingToExcel()">Exportar a Excel</v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-checkbox v-model="hidePagination" label="Ocultar numeración de páginas"></v-checkbox>
                </v-col>
                <v-col cols="12" md="5">
                    <v-checkbox v-model="hideCodes" label="Ocultar códigos de generación y números de control"></v-checkbox>
                </v-col>
            </v-row>

            <template v-if="reportType === '2'">
                <br/>
            </template>

            <GeneralFilter v-if="reportType === '1'" :filterEndpoint="$API.accountingreports.getSearchSalesByDate"
                :search="{ ...search, reportType, dataType, allBranch }" @emptyFilter="getReportSales" @filtered="filterHandler">
                <DxDataGrid 
                    v-if="reportType === '1'" 
                    :ref="nameDxDataGrid + reportType + printType" 
                    :key="`csv-taxpayer-${reportType}-${printType}`"
                    :dataSource="DataTable" 
                    :columns="columnsTaxPayer2"
                    @exporting="onExporting"
                    :word-wrap-enabled="true" 
                    :column-auto-width="true" 
                    :scrolling="{ useNative: true }"
                    >
                    <DxExport :enabled="true" />
                    <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                    <DxPaging defaultPageSize="5" />

                    <DxSummary>
                        <DxTotalItem
                        column="FECHA EMISIÓN DEL DOCUMENTO"
                        display-format="TOTALES"
                        />
                        <DxTotalItem
                        column="ExportacionesFormatted"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        
                        />
                        <DxTotalItem
                        column="VENTAS EXENTAS"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        
                        />
                        <DxTotalItem
                        column="VENTAS GRAVADAS LOCALES"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        column="DÉBITO FISCAL"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        column="DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        column="VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        column="ImpuestoPercibidoFormatted"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                            column="RETENCIÓN IVA 1"
                            summary-type="sum"
                            :value-format="customCurrencyFormat"
                            display-format="{0}"
                            cssClass="right-column"
                        />
                        <DxTotalItem
                        column="TOTAL VENTAS"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        v-if="showFovial"
                        column="Fovial"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                        <DxTotalItem
                        v-if="showCotrans"
                        column="Cotrans"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="{0}"
                        cssClass="right-column"
                        />
                    </DxSummary>
                </DxDataGrid>
            </GeneralFilter>
            <DxDataGrid 
                :ref="nameDxDataGrid + reportType + printType" 
                :key="`csv-taxpayer-${reportType}-${printType}`"
                v-if="reportType === '2'" :dataSource="DataTable2" 
                :columns="columnsFinalCustomer2" 
                @exporting="onExporting"
                :word-wrap-enabled="true" :scrolling="{ useNative: true }">
                <DxExport :enabled="true" />
                <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                <DxPaging defaultPageSize="5" />
            
                <DxSummary>
                    <DxTotalItem
                    column="InvoiceDate"
                    display-format="TOTALES"
                    />
                    <DxTotalItem
                    column="VentasExentas"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"                        
                    />
                    <DxTotalItem
                    column="VentasGravadasLocales"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="VentasNoSujetas"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                        column="IvaRetencion"
                        summary-type="sum"
                        :value-format="customCurrencyFormat"
                        display-format="${0}"
                        cssClass="right-column"
                    />
                    <DxTotalItem
                    column="Exportaciones"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="VentaACuentaDeTercerosNoDomiciliados"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="TotalVentas"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="${0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    v-if="showFovial"
                    column="Fovial"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    v-if="showCotrans"
                    column="Cotrans"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                </DxSummary>
            </DxDataGrid>
        </template>
        
        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>

        <!-- Modal de edición de Tipo de Ingreso -->
        <v-dialog v-model="editDialog.show" max-width="600px" persistent>
            <v-card>
                <v-card-title class="headline lighten-4">
                    <v-icon color="success" class="mr-2">mdi-pencil</v-icon>
                    Edición de Tipo de Ingreso
                </v-card-title>
                <v-card-text class="pt-4">
                    <div class="subtitle-2 grey--text text--darken-1 mb-3">
                        Edite el tipo de ingreso del cliente. Este cambio se reflejará en todos los comprobantes del cliente.
                    </div>
                    <v-card outlined class="mb-4 pa-3">
                        <div class="subtitle-2 mb-2"><strong>Información del comprobante:</strong></div>
                        <div><strong>Cliente:</strong> {{ editDialog.data['NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN'] }}</div>
                        <div><strong>NIT/NRC:</strong> {{ editDialog.data['NIT O NRC DEL CLIENTE'] }}</div>
                        <div><strong>Número de documento:</strong> {{ editDialog.data['NÚMERO DE DOCUMENTO'] }}</div>
                    </v-card>

                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="editDialog.data['TIPO DE INGRESO']"
                                :items="tipoIngresoClientes"
                                item-text="Valores"
                                item-value="Codigo"
                                label="Tipo de Ingreso *"
                                outlined
                                dense
                                clearable
                                :rules="[v => !!v || 'Campo requerido']"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeEditDialog">
                        Cancelar
                    </v-btn>
                    <v-btn 
                        color="success"
                        @click="saveEditedData"
                        :disabled="!isFormValid()"
                        :loading="loading"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Guardar cambios
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <component v-for="win in windowsList" :is="win.component" :key="win.key" v-bind="win.props" />
    </div>
</template>

<script>

//import {mapState} from 'vuex';
import {mapGetters} from 'vuex';
import { DxDataGrid, DxPager, DxPaging, DxExport, DxSummary, DxTotalItem, DxColumn } from 'devextreme-vue/data-grid';
import GeneralFilter from '../../../components/GeneralFilter.vue';
import Alerts from '@/components/Alerts.vue';
import Block from '@/components/Block.vue';
import { printToExcel } from "@/helpers/printToexcel";
import { jsPDF } from 'jspdf'
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/pdf_exporter';

import SubPrint from '../SubPrint.vue';
import { addSignaturesAccountantAndAuditor } from '../../../utils/addSignatures';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
    name: "SalesReport",
    components: {
        DxDataGrid,
        DxPager,
        DxPaging,
        SubPrint,
        Block,
        Alerts,
        GeneralFilter,
        //  PrintReportsSales,
        DxExport,
        DxSummary, 
        DxTotalItem,
        DxColumn
    },
    props: ['win'],
    watch: {
        reportType(newVal) {
            this.search.reportType = newVal;
        },
        dataType(newVal) {
            this.search.dataType = newVal;
        },
        hideCodes(newVal) {
            if (newVal) {
                this.columnsFinalCustomer2 = [ //UTILIZA EL sp_Ventas_Consumidor_Final_Agrupado
                    { dataField: "InvoiceDate", caption: "Fecha" },
                    { dataField: "", caption: "Código de Generación Inicial" },
                    { dataField: "", caption: "Código de Generación Final" },
                    { dataField: "", caption: "Número de Control Del" },
                    { dataField: "", caption: "Número de Control Al" },
                    { dataField: "VentasExentas", caption: "Ventas Exentas" },
                    { dataField: "VentasNoSujetas", caption: "Ventas No Sujetas" },
                    { dataField: "VentasGravadasLocales", caption: "Ventas Gravadas" },
                    { dataField: "IvaRetencion", caption: "Retención IVA" },
                    { dataField: "Exportaciones", caption: "Exportaciones" }, //No se si seria este
                    { dataField: "TotalVentas", caption: "Venta Total" },
                ]
            } else {
                this.columnsFinalCustomer2 = [ //UTILIZA EL sp_Ventas_Consumidor_Final_Agrupado
                    { dataField: "InvoiceDate", caption: "Fecha" },
                    { dataField: "NumeroDeDocumentoDel", caption: "Código de Generación Inicial" },
                    { dataField: "NumeroDeDocumentoAl", caption: "Código de Generación Final" },
                    { dataField: "NumeroControlInicial", caption: "Número de Control Del" },
                    { dataField: "NumeroControlFinal", caption: "Número de Control Al" },
                    { dataField: "VentasExentas", caption: "Ventas Exentas" },
                    { dataField: "VentasNoSujetas", caption: "Ventas No Sujetas" },
                    { dataField: "VentasGravadasLocales", caption: "Ventas Gravadas" },
                    { dataField: "IvaRetencion", caption: "Retención IVA" },
                    { dataField: "Exportaciones", caption: "Exportaciones" }, //No se si seria este
                    { dataField: "TotalVentas", caption: "Venta Total" },
                ]
            }
        },
    },
    data() {
        return {
            windowsList: [

            ],
            print: {
                show: false,
                header: {
                    month: null,
                    year: null,
                    reportType: null,
                },
                data: [],
            },
            dataType: '01',
            printType: '1',
            reportType: '1',
            showPrint: false,
            reloadPrint: 0,
            allBranch: false,
            DataTable: [],
            DataTable2: [],
            panel: 0,
            tab: null,
            key: 0,
            loading: false,
            search: {
                month: null,
                year: null,
                reportType: '1'
            },
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            monthList: [
                { text: 'Enero', value: 1 },
                { text: 'Febrero', value: 2 },
                { text: 'Marzo', value: 3 },
                { text: 'Abril', value: 4 },
                { text: 'Mayo', value: 5 },
                { text: 'Junio', value: 6 },
                { text: 'Julio', value: 7 },
                { text: 'Agosto', value: 8 },
                { text: 'Septiembre', value: 9 },
                { text: 'Octubre', value: 10 },
                { text: 'Noviembre', value: 11 },
                { text: 'Diciembre', value: 12 },
            ],
            monthListDefault: [
                { MES: 'Enero', monthIndex: 1 },
                { MES: 'Febrero', monthIndex: 2 },
                { MES: 'Marzo', monthIndex: 3 },
                { MES: 'Abril', monthIndex: 4 },
                { MES: 'Mayo', monthIndex: 5 },
                { MES: 'Junio', monthIndex: 6 },
                { MES: 'Julio', monthIndex: 7 },
                { MES: 'Agosto', monthIndex: 8 },
                { MES: 'Septiembre', monthIndex: 9 },
                { MES: 'Octubre', monthIndex: 10 },
                { MES: 'Noviembre', monthIndex: 11 },
                { MES: 'Diciembre', monthIndex: 12 },
            ],
            yearLIst: [
                { text: '2020', value: 2020 },
                { text: '2021', value: 2021 },
                { text: '2022', value: 2022 },
                { text: '2023', value: 2023 },
            ],
            columnsTaxPayer: [
                { dataField: "FECHA EMISIÓN DEL DOCUMENTO", caption: "FECHA EMISIÓN DEL DOCUMENTO" },
                { dataField: "CLASE DE DOCUMENTO", caption: "CLASE DE DOCUMENTO" },
                { dataField: "TIPO DE DOCUMENTO", caption: "TIPO DE DOCUMENTO" },
                { dataField: "NÚMERO DE RESOLUCIÓN", caption: "NÚMERO DE RESOLUCIÓN" },
                { dataField: "NUMERO DE SERIE DE DOCUMENTO", caption: "NUMERO DE SERIE DE DOCUMENTO" },
                { dataField: "NÚMERO DE DOCUMENTO", caption: "NÚMERO DE DOCUMENTO" },
                { dataField: "NÚMERO DE CONTROL INTERNO", caption: "NÚMERO DE CONTROL INTERNO" },
                { dataField: "NIT O NRC DEL CLIENTE", caption: "NIT O NRC DEL CLIENTE" },
                { dataField: "NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN", caption: "NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN" },
                { dataField: "VentasExentasFormatted", caption: "VENTAS EXENTAS" },
                { dataField: "VentasNoSujetasFormatted", caption: "VENTAS NO SUJETAS" },
                { dataField: "VentasGravadasLocalesFormatted", caption: "VENTAS GRAVADAS LOCALES" },
                { dataField: "DebitoFiscalFormatted", caption: "DÉBITO FISCAL" },
                { dataField: "VentasCuentaDeTercerosNoDomiciliadosFormatted", caption: "VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS" },
                { dataField: "DebitoFiscalVentaTercerosFormatted", caption: "DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS" },
                { dataField: "RetencionIVA1Formatted", caption: "Retención IVA" },
                { dataField: "TotalVentasFormatted", caption: "TOTAL VENTAS" },
                { dataField: "TIPO DE INGRESO", caption: "TIPO DE INGRESO", required: true },
                { dataField: "NÚMERO DE ANEXO", caption: "NÚMERO DE ANEXO" },
            ],
            columnsTaxPayer2: [
                { dataField: "FECHA EMISIÓN DEL DOCUMENTO", caption: "Fecha" },
                { dataField: "NÚMERO DE DOCUMENTO", caption: "Código Generación" },
                { dataField: "", caption: "F. Único" }, //No existe
                { dataField: "NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN", caption: "Cliente" },
                { dataField: "NIT O NRC DEL CLIENTE", caption: "NRC" },
                { dataField: "VENTAS GRAVADAS LOCALES", caption: "Ventas Gravadas" }, //No existe
                { dataField: "DÉBITO FISCAL", caption: "Débito Fiscal" },
                { dataField: "DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS", caption: "Débito Fiscal Venta a Cuenta de Terceros" },
                { dataField: "ImpuestoPercibidoFormatted", caption: "Impuesto percibido" }, //No existe
                { dataField: "RETENCIÓN IVA 1", caption: "Retención IVA" },
                { dataField: "TOTAL VENTAS", caption: "Ventas Totales" },
            ],
            columnsFinalCustomer: [
                { dataField: "InvoiceDate", caption: "FECHA DE EMISIÓN" },
                { dataField: "ClaseDeDocumento", caption: "CLASE DE DOCUMENTO" },
                { dataField: "TipoDeDocumento", caption: "TIPO DE DOCUMENTO" },
                { dataField: "NumeroDeResolucion", caption: "NÚMERO DE RESOLUCIÓN" },
                { dataField: "SerieDeDocumento", caption: "SERIE DEL DOCUMENTO" },
                { dataField: "NumeroDeControlInternoDel", caption: "NÚMERO DE CONTROL INTERNO (DEL)" },
                { dataField: "NumeroDeControlInternoDelAl", caption: "NÚMERO DE CONTROL INTERNO (AL)" },
                { dataField: "NumeroDeDocumentoDel", caption: "NÚMERO DE DOCUMENTO (DEL)" },
                { dataField: "NumeroDeDocumentoAl", caption: "NÚMERO DE DOCUMENTO (AL)" },
                { dataField: "NoDeMaquinaRegistradora", caption: "NÚMERO DE MÁQUINA REGISTRADORA" },
                { dataField: "VentasExentas", caption: "VENTAS EXENTAS" },
                { dataField: "VentasInternasExentasNoSujetasAProporcionalidad", caption: "VENTAS INTERNAS EXENTAS NO SUJETAS A PROPORCIONALIDAD" },
                { dataField: "VentasNoSujetas", caption: "VENTAS NO SUJETAS" },
                { dataField: "VentasGravadasLocales", caption: "VENTAS GRAVADAS LOCALES" },
                { dataField: "IvaRetencion", caption: "Retención IVA" },
                { dataField: "ExportacionesDentroDelAreaCentroamericana", caption: "EXPORTACIONES DENTRO DEL ÁREA CENTROAMERICANA" },
                { dataField: "ExportacionesFueraDelAreaCentroamericana", caption: "EXPORTACIONES FUERA DEL ÁREA CENTROAMERICANA" },
                { dataField: "ExportacionesDeServicios", caption: "EXPORTACIONES DE SERVICIOS" },
                { dataField: "VentasAZonasFrancasYDPATasaCero", caption: "VENTAS A ZONAS FRANCAS Y DPA (TASA CERO)" },
                { dataField: "VentaACuentaDeTercerosNoDomiciliados", caption: "VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS" },
                { dataField: "TotalVentas", caption: "TOTAL VENTAS" },
                { dataField: "NumeroDeAnexo", caption: "NÚMERO DE ANEXO" },
            ],
            columnsFinalCustomer2: [ //UTILIZA EL sp_Ventas_Consumidor_Final_Agrupado
                { dataField: "InvoiceDate", caption: "Fecha" },
                { dataField: "NumeroDeDocumentoDel", caption: "Código de Generación Inicial" },
                { dataField: "NumeroDeDocumentoAl", caption: "Código de Generación Final" },
                { dataField: "NumeroControlInicial", caption: "Número de Control Del" },
                { dataField: "NumeroControlFinal", caption: "Número de Control Al" },
                { dataField: "VentasExentas", caption: "Ventas Exentas" },
                { dataField: "VentasNoSujetas", caption: "Ventas No Sujetas" },
                { dataField: "VentasGravadasLocales", caption: "Ventas Gravadas" },
                { dataField: "IvaRetencion", caption: "Retención IVA" },
                { dataField: "TotalVentas", caption: "Venta Total" },
            ],
            nameDxDataGrid: "dataGrid",
            hidePagination: false,
            hideCodes: false,
            AccountantName: JSON.parse(localStorage.getItem("user")).AccountantName,
            AccountantAdditional: JSON.parse(localStorage.getItem("user")).AccountantAdditional,
            AuditorName: JSON.parse(localStorage.getItem("user")).AuditorName,
            AuditorAdditional: JSON.parse(localStorage.getItem("user")).AuditorAdditional,
            keymaster: JSON.parse(localStorage.getItem("user")).keymaster,
            invalidRowsCount: 0,
            editDialog: {
                show: false,
                data: {},
                originalData: {}
            }
        }
    },
    computed: {
        ...mapGetters(["getCatalogMH"]),
        tipoIngresoClientes() {
            return this.getCatalogMH('TipoIngreso');
        },
        showFovial(){
            return ['83be6f5fdcc4a9e3305faa5c098a9990'].includes(this.keymaster) 
        },
        showCotrans(){
            return ['83be6f5fdcc4a9e3305faa5c098a9990'].includes(this.keymaster) 
        },
        isHR(){
            return ['7578075a2716744af3f61bdc24037bf7'].includes(this.keymaster) 
        },
        ventasTerceros(){
            return ['452476470895e11843a44d7053b6521e'].includes(this.keymaster)
        },
    },
    async mounted() {
        // Cargar catálogos de Hacienda
        await this.$store.dispatch('getCatalogMH');
        
        this.yearLIst = (await this.$API.accountingreports.getSalesDateYears())?.years;
        if (this.yearLIst && this.yearLIst.length > 0)
        this.search.year = this.yearLIst[this.yearLIst.length - 1]?.AÑO;

        if (['7dbaa6c5d1580847e0a49fdf483368fb'].includes(this.keymaster)) {
            this.monthList = this.monthListDefault;
        }else{
            this.monthList = (await this.$API.accountingreports.getSalesDateMonths(this.search))?.months
            if (this.monthList && this.monthList.length > 0) 
            this.search.month = this.monthList[this.monthList.length - 1]?.monthIndex;
        }

        if (this.showFovial) {
            const fovial = {
                dataField: "Fovial",
                caption: "FOVIAL"
            };
            this.columnsTaxPayer2.push(fovial);
            this.columnsFinalCustomer2.push(fovial)
        }
         if (this.showCotrans) {
            const cotrans = {
                dataField: "Cotrans",
                caption: "COTRANS"
            }
            this.columnsTaxPayer2.push(cotrans);
            this.columnsFinalCustomer2.push(cotrans)
        }
        let optionalColumTaxPayer2 = { dataField: "ExportacionesFormatted", caption: "Exportaciones"  };
        let optionalColPosition = 5;
        let optionalColcolumnsFinalCustomer2 = { dataField: "Exportaciones", caption: "Exportaciones" };
        if(this.isHR){
            optionalColumTaxPayer2 = { dataField: "VENTAS EXENTAS", caption: "Exentas"  };
        }else if(this.ventasTerceros) {
            optionalColumTaxPayer2 = { dataField: "VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS", caption: "Venta a Cuenta de Terceros" }
            optionalColPosition = 7;
            optionalColcolumnsFinalCustomer2 = { dataField: "VentaACuentaDeTercerosNoDomiciliados", caption: "Venta a Cuenta de Terceros" };
        }
        this.columnsTaxPayer2.splice(optionalColPosition, 0, optionalColumTaxPayer2);
        this.columnsFinalCustomer2.splice(9, 0, optionalColcolumnsFinalCustomer2)


    },
    async beforeUpdate() {
        const checkboxElement = this.$refs.integrateBrachCheckbox.$el.querySelector('input[type="checkbox"]');

        if (checkboxElement.checked != this.allBranch) {
            await this.getReportSales()
        }
    },
    methods: {
        // Método helper para validar si un valor está vacío o es inválido
        isEmptyOrInvalid(value) {
            return (
                value === null ||
                value === undefined ||
                String(value).trim() === '' ||
                String(value).trim() === 'null'
            );
        },
        onRowPrepared(e) {
            if (e.rowType !== 'data') return;
            const hasRequiredEmpty = e.component
            .getVisibleColumns()
            .some(col => {
                if (!col.required) return false;

                const value = e.data[col.dataField];
                return this.isEmptyOrInvalid(value);
            });

            if (hasRequiredEmpty) {
                e.rowElement.classList.add('errorRow');
            }
        },
        countInvalidRows(data, columns) {
            if (!Array.isArray(data) || !Array.isArray(columns)) return 0;

            const requiredFields = columns
                .filter(col => col.required && col.dataField)
                .map(col => col.dataField);

            if (requiredFields.length === 0) return 0;

            return data.filter(row =>
                requiredFields.some(field => {
                    const value = row[field];
                    return this.isEmptyOrInvalid(value) || value === 0;
                })
            ).length;
        },
        getAlerts(){
            this.DataTable = this.sortByRequired(this.DataTable, this.columnsTaxPayer);
        },
        sortByRequired(data, columns) {
            if (!Array.isArray(data) || !Array.isArray(columns)) return data;

            const requiredFields = columns
                .filter(col => col.required && col.dataField)
                .map(col => col.dataField);

            if (requiredFields.length === 0) return data;

            return [...data].sort((a, b) => {
                const aInvalid = requiredFields.some(field => {
                    return this.isEmptyOrInvalid(a[field]);
                });

                const bInvalid = requiredFields.some(field => {
                    return this.isEmptyOrInvalid(b[field]);
                });
                return Number(bInvalid) - Number(aInvalid);
            });
        },
        customCurrencyFormat(value) {
            if (value == null) return ''; 
            return parseFloat(value).toFixed(2); 
        },
        moneyFormat(value, currency ='$'){
            if (!value) 
                return currency + '0.00';

            const number = parseFloat(value).toFixed(2);
            const parts = number.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return currency + parts.join('.');
        },
        sanitizeText(text = '') {
            return text
                .replace(/[\u2013\u2014]/g, '-')
                .replace(/[^\x20-\x7EñÑáéíóúÁÉÍÓÚüÜ¿¡]/g, '')
                .trim();
        },
        async onExportingToPdf() {
            const doc = this.reportType == '1' ? new jsPDF('landscape') : new jsPDF(); 
            var spColumnsWidth = []

            if (this.reportType == '1') {
                spColumnsWidth = [16, 52, 13, 34, 25, 20, 20, 20, 20, 20, 20]
                if(this.showCotrans || this.showFovial)
                   spColumnsWidth = [16, 40, 10, 34, 15, 15, 15, 20, 15, 20, 15, 20, 15,15]
            }

            if (this.reportType == '2') {
                spColumnsWidth = [16, 17, 17, 17, 17, 14, 14, 20, 20, 20]
                if(this.showCotrans || this.showFovial)
                    spColumnsWidth = [16, 17, 17, 17, 17, 12, 12, 15, 12, 12, 15, 12, 12];
                //spColumnsWidth = [16, 35, 35, 35, 35, 22, 22, 22, 22, 22]
            }

            const [ businessInfo ] = await this.$API.branches.findSpecificBranch({ branch: JSON.parse(localStorage.getItem("user")).branch, business: JSON.parse(localStorage.getItem("user")).businessid })
            const businessName = this.sanitizeText(businessInfo.BusinessBillingName || '')
            exportDataGrid({
                jsPDFDocument: doc,
                component: this.$refs[this.nameDxDataGrid + this.reportType + this.printType].instance,
                margin: { top: 40, right: 10, bottom: 20, left: 10 },
                columnWidths: spColumnsWidth,
                customizeCell: function (options) {
                    options.pdfCell.font.size = 7;
                },
            }).then(() => {
                var pageCount = parseInt(doc.internal.getNumberOfPages()) + 1;
                var header = ""
                var header2 = ""
                var header3 = ""
                var header4 = ""
                var header5 = ""

                for(var i = 0; i < pageCount; i++){
                    doc.setPage(i + 1);
                    doc.setFontSize(7)
                    
                    if (!this.hidePagination) {
                        let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                        doc.text ('page:  ' + pageCurrent + ' / ' + pageCount ,10,10);
                    }

                    if (this.reportType == "1") {
                        let month = this.monthList.find(item => item.monthIndex === this.search.month)
                        header = `${ businessName }`
                        header2 = `Libro de Ventas a Contribuyentes`
                        header3 = `Registro de IVA Número: ${JSON.parse(localStorage.getItem("user")).businessnrc}`
                        header4 = `Periodo Tributario: ${month.MES} de ${this.search.year}`
                        header5 = `Cantidades Expresadas en Dolares de Estados Unidos de America`
                    }

                    if (this.reportType == "2") {
                        let month = this.monthList.find(item => item.monthIndex === this.search.month)
                        header = `${ businessName }`
                        header2 = `Libro de Ventas a Consumidor`
                        header3 = `Registro de IVA Número: ${JSON.parse(localStorage.getItem("user")).businessnrc}`
                        header4 = `Periodo Tributario: ${month.MES} de ${this.search.year}`
                        header5 = `Cantidades Expresadas en Dolares de Estados Unidos de America`
                    }
                    
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const headerWidth = doc.getTextDimensions(header).w;
                    const headerWidth2 = doc.getTextDimensions(header2).w;
                    const headerWidth3 = doc.getTextDimensions(header3).w;
                    const headerWidth4 = doc.getTextDimensions(header4).w;
                    const headerWidth5 = doc.getTextDimensions(header5).w;
                    doc.setFontSize(10);
                    doc.text(header, (pageWidth - headerWidth) / 2, 8);
                    doc.text(header2, (pageWidth - headerWidth2) / 2, 13);
                    doc.text(header3, (pageWidth - headerWidth3) / 2, 18);
                    doc.text(header4, (pageWidth - headerWidth4) / 2, 23);
                    doc.text(header5, (pageWidth - headerWidth5) / 2, 28);
                }

                doc.addPage();
                doc.setFontSize(7)

                if(!this.hidePagination) {
                    doc.text ('page:  ' + pageCount + ' / ' + pageCount ,10,10);
                }
                
                const pageWidth = doc.internal.pageSize.getWidth();
                const headerWidth = doc.getTextDimensions(header).w;
                const headerWidth2 = doc.getTextDimensions(header2).w;
                const headerWidth3 = doc.getTextDimensions(header3).w;
                const headerWidth4 = doc.getTextDimensions(header4).w;
                const headerWidth5 = doc.getTextDimensions(header5).w;
                doc.setFontSize(10);
                doc.text(header, (pageWidth - headerWidth) / 2, 8);
                doc.text(header2, (pageWidth - headerWidth2) / 2, 13);
                doc.text(header3, (pageWidth - headerWidth3) / 2, 18);
                doc.text(header4, (pageWidth - headerWidth4) / 2, 23);
                doc.text(header5, (pageWidth - headerWidth5) / 2, 28);

                doc.setFontSize(10);
                if (this.reportType == "1") {
                    //CONTRIBUYENTES
                    const exentas = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VENTAS EXENTAS"])
                    }, 0)
                    const nosujetas = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VENTAS NO SUJETAS"])
                    }, 0)
                    
                    const gravadas = this.DataTable.reduce((accumulator, currentValue) => {
                        if (currentValue?.is_tercero) return;
                        return accumulator + parseFloat(currentValue["VENTAS GRAVADAS LOCALES"])
                    }, 0)
                    const debitoFiscal = this.DataTable.reduce((accumulator, currentValue) => {
                        if (currentValue?.is_tercero) return;
                        return accumulator + parseFloat(currentValue["DÉBITO FISCAL"])
                    }, 0)
                    const iva = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["RETENCIÓN IVA 1"])
                    }, 0)

                    const fovial = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Fovial"])
                    }, 0)
                    const cotrans = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Cotrans"])
                    }, 0)
                    const ventas_terceros = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS"])
                    }, 0)
                    const debito_terceros = this.DataTable.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS"])
                    }, 0)
                    
                    //CONSUMIDORES FINALES
                    let gravadas2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasGravadasLocales"])
                    }, 0)
                    const nosujetas2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasNoSujetas"])
                    }, 0)
                    /*const debitoFiscal2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Iva"])
                    }, 0)*/
                    const exportaciones2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Exportaciones"])
                    }, 0)
                    const exentas2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasExentas"])
                    }, 0)
                    const iva2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["IvaRetencion"])
                    }, 0)
                    const fovial2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Fovial"])
                    }, 0)
                    const cotrans2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Cotrans"])
                    }, 0)
                    const ventas_terceros2 = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentaACuentaDeTercerosNoDomiciliados"])
                    }, 0)

                    const gravadas_terceros2 = parseFloat(ventas_terceros2) / 1.13;
                    const debito_terceros2 = gravadas_terceros2 * 0.13;
                    gravadas2 = parseFloat(gravadas2) / 1.13;
                    const debitoFiscal2 = gravadas2 * 0.13;
                    const total = parseFloat(exentas) + parseFloat(gravadas) + parseFloat(debitoFiscal) + parseFloat(nosujetas) - parseFloat(iva)
                    const total2 = parseFloat(gravadas2) + parseFloat(nosujetas2) + parseFloat(exportaciones2) + parseFloat(exentas2) + parseFloat(debitoFiscal2) - parseFloat(iva2)
                    const totalGravadas = parseFloat(gravadas) + parseFloat(gravadas2)
                    const totalExentas = parseFloat(exentas2) +  parseFloat(exentas)
                    const totalNoSujeta = parseFloat(nosujetas) +  parseFloat(nosujetas2)
                    const totalExportC = parseFloat(exportaciones2)
                    const totalDebitoFiscal = parseFloat(debitoFiscal) + parseFloat(debitoFiscal2)
                    const ivaTotal = parseFloat(iva) + parseFloat(iva2)
                    const FovialTotal = parseFloat(fovial) + parseFloat(fovial2)
                    const CotransTotal = parseFloat(cotrans) + parseFloat(cotrans2)
                    const DebitoTercerosTotal = parseFloat(debito_terceros) + parseFloat(debito_terceros2)
                    const VentasTercerosTotal = parseFloat(ventas_terceros) + parseFloat(gravadas_terceros2)
                    const totalTotal = parseFloat(total) + parseFloat(total2)
                    const header = ['DETALLE DEL LIBRO','EXENTAS', 'NOSUJETAS','GRAVADAS','EXPORTC.','DEBITO FISCAL','TOTAL','IVA RETE.'];
                    const rowConsumidores = [
                    'CONSUMIDORES FINALES',
                    this.moneyFormat(exentas2),
                    this.moneyFormat(nosujetas2),
                    this.moneyFormat(gravadas2),
                    this.moneyFormat(exportaciones2),
                    this.moneyFormat(debitoFiscal2),
                    this.moneyFormat(total2),
                    this.moneyFormat(iva2)
                    ];

                    const rowContribuyentes = [
                    'CONTRIBUYENTES',
                    this.moneyFormat(exentas),
                    this.moneyFormat(nosujetas),
                    this.moneyFormat(gravadas),
                    '0.00',
                    this.moneyFormat(debitoFiscal),
                    this.moneyFormat(total),
                    this.moneyFormat(iva)
                    ];

                    const rowTotales = [
                    'TOTALES',
                    this.moneyFormat(totalExentas),
                    this.moneyFormat(totalNoSujeta),
                    this.moneyFormat(totalGravadas),
                    this.moneyFormat(totalExportC),
                    this.moneyFormat(totalDebitoFiscal),
                    this.moneyFormat(totalTotal),
                    this.moneyFormat(ivaTotal)
                    ];
                    if (this.showFovial || this.showCotrans) {
                        header.push('FOVIAL');
                        rowConsumidores.push(this.moneyFormat(fovial2));
                        rowContribuyentes.push(this.moneyFormat(fovial));
                        rowTotales.push(this.moneyFormat(FovialTotal));
                        header.push('COTRANS');
                        rowConsumidores.push(this.moneyFormat(cotrans2));
                        rowContribuyentes.push(this.moneyFormat(cotrans));
                        rowTotales.push(this.moneyFormat(CotransTotal));
                    }
                     if (this.ventasTerceros) {
                        
                        header.push('VENT. TERCEROS');
                        rowConsumidores.push(this.moneyFormat(gravadas_terceros2));
                        rowContribuyentes.push(this.moneyFormat(ventas_terceros));
                        rowTotales.push(this.moneyFormat(VentasTercerosTotal));
                        header.push('IVA TERCEROS');
                        rowConsumidores.push(this.moneyFormat(debito_terceros2));
                        rowContribuyentes.push(this.moneyFormat(debito_terceros));
                        rowTotales.push(this.moneyFormat(DebitoTercerosTotal));
                    }
                    const footerData = [
                        header,
                        rowConsumidores,
                        rowContribuyentes,
                        rowTotales
                    ];

                    let contentEndY = 33;

                    const tableConfig = {
                        startY: contentEndY, // Comienza en la posición Y indicada (260)
                        head: [footerData[0]], // La primera fila es el encabezado
                        body: footerData.slice(1), // Las filas siguientes son los datos
                        theme: 'plain', // Estilo de la tabla
                        headStyles: { fillColor: [255, 255, 255], fontSize: 10 },
                        bodyStyles: { fontSize: 10 },
                        margin: { left: 5, right: 5 }, // Márgenes
                        columnStyles: {
                            0: { cellWidth: 'auto' }, // La primera columna (DETALLE DEL LIBRO) tiene ancho automático
                            1: { halign: 'right' }, // Alinear a la derecha la columna 'EXENTAS'
                            2: { halign: 'right' }, // Alinear a la derecha la columna 'GRAVADAS'
                            3: { halign: 'right' }, // Alinear a la derecha la columna 'EXPORTC.'
                            4: { halign: 'right' }, // Alinear a la derecha la columna 'DEBITO FISCAL'
                            5: { halign: 'right' }, // Alinear a la derecha la columna 'TOTAL'
                            6: { halign: 'right' }, // Alinear a la derecha la columna 'IVA RETENIDO'
                        }, 
                        tableWidth: 'auto', // Ancho automático de las columnas
                    };

                    doc.autoTable(tableConfig);

                    addSignaturesAccountantAndAuditor({
                        doc, 
                        positionY: 105, 
                        leftLineMargin: 60,
                        longLine: 80,
                        AccountantName: this.AccountantName, 
                        AccountantAdditional: this.AccountantAdditional, 
                        AuditorName: this.AuditorName,
                        AuditorAdditional: this.AccountantAdditional
                    })
                }

                if (this.reportType == "2") {

                    const gravadas = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasGravadasLocales"])
                    }, 0)
                    const nosujetas = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasNoSujetas"])
                    }, 0)
                   /* const debitoFiscal = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Iva"])
                    }, 0)
                    */
                    const exportaciones = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Exportaciones"])
                    }, 0)
                    const exentas = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentasExentas"])
                    }, 0)
                    const ventas_terceros_cf = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["VentaACuentaDeTercerosNoDomiciliados"])
                    }, 0)

                    const iva = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["IvaRetencion"])
                    }, 0)
                    const fovial = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Fovial"])
                    }, 0)

                    const cotrans = this.DataTable2.reduce((accumulator, currentValue) => {
                        return accumulator + parseFloat(currentValue["Cotrans"])
                    }, 0)
                    const total = gravadas + nosujetas + exportaciones + exentas
                    let fovcon = ``;
                    if(this.showFovial || this.showCotrans){
                        fovcon =    `FOVIAL                                                                                         ${parseFloat(fovial).toFixed(2)} \n
                                    COTRANS                                                                                    ${parseFloat(cotrans).toFixed(2)} \n
                    `;
                    }
                    const gravadasNetasTotal = gravadas / 1.13;
                    const ivaTotal = gravadasNetasTotal * 0.13;
                    const footerText = `
                                    CALCULO DEL DÉBITO FISCAL: \n
                                    VENTAS NETAS GRAVADAS                                                      ${parseFloat(gravadasNetasTotal).toFixed(2)} \n
                                    13% DEBITO FISCAL                                                                   ${parseFloat(ivaTotal).toFixed(2)} \n
                                    EXPORTACIONES                                                                       ${parseFloat(exportaciones).toFixed(2)} \n
                                    EXENTAS                                                                                     ${parseFloat(exentas).toFixed(2)} \n
                                    NO SUJETAS                                                                               ${parseFloat(nosujetas).toFixed(2)} \n
                                    ---------------------------
                                    TOTAL VENTA GRAVADA                                                           ${parseFloat(total).toFixed(2)}\n
                                    TOTAL VENTA A CUENTA DE TERCEROS                               ${parseFloat(ventas_terceros_cf).toFixed(2)}\n
                                    RETENCIÓN IVA                                                                          ${parseFloat(iva).toFixed(2)} \n
                                    ${fovcon}
                                    \n\n
                    `;
                    let contentEndY = 45;
                    doc.text(footerText, 10, contentEndY);

                    addSignaturesAccountantAndAuditor({
                        doc, 
                        positionY: 145, 
                        leftLineMargin: 20,
                        longLine: 75,
                        AccountantName: this.AccountantName, 
                        AccountantAdditional: this.AccountantAdditional, 
                        AuditorName: this.AuditorName,
                        AuditorAdditional: this.AccountantAdditional
                    })
                }

                if (this.reportType == "1") {
                    let month = this.monthList.find(item => item.monthIndex === this.search.month)
                    doc.save(`Reporte de ventas (Contribuyentes) - ${month.MES} de ${this.search.year}.pdf`);
                }

                if (this.reportType == "2") {
                    let month = this.monthList.find(item => item.monthIndex === this.search.month)
                    doc.save(`Reporte de ventas (Consumidores Finales) - ${month.MES} de ${this.search.year}.pdf`);
                }
                
            });
        },
        async onExportingToExcel() {
            if (this.reportType !== '1' && this.reportType !== '2') {
                this.showAlert("warning", "Advertencia", "Esta función solo está disponible para Contribuyentes y Consumidores Finales.");
                return;
            }

            try {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Ventas');
                
                // Obtener información del negocio
                const [ businessInfo ] = await this.$API.branches.findSpecificBranch({ 
                    branch: JSON.parse(localStorage.getItem("user")).branch, 
                    business: JSON.parse(localStorage.getItem("user")).businessid 
                });
                const businessName = this.sanitizeText(businessInfo.BusinessBillingName || '');
                const month = this.monthList.find(item => item.monthIndex === this.search.month);
                
                if (this.reportType === '1') {
                    // ========== CONTRIBUYENTES ==========
                    await this.generateExcelContribuyentes(workbook, worksheet, businessName, month);
                } else {
                    // ========== CONSUMIDORES FINALES ==========
                    await this.generateExcelConsumidores(workbook, worksheet, businessName, month);
                }
                
            } catch (error) {
                console.error('Error al generar Excel:', error);
                this.showAlert("danger", "Error", "Ocurrió un error al generar el archivo Excel.");
            }
        },
        async generateExcelContribuyentes(workbook, worksheet, businessName, month) {
                
                // Configurar el ancho de las columnas
                worksheet.columns = [
                    { width: 4 },   // N°
                    { width: 12 },  // FECHA DE EMISION
                    { width: 20 },  // CODIGO DE GENERACION O NUMERO DE CORRELATIVO
                    { width: 20 },  // SELLO DE RECEPCION O NUMERO DE SERIE DEL DOCUMENTO
                    { width: 20 },  // NUMERO DE CONTROL O NUMERO DE RESOLUCION DEL DOCUMENTO
                    { width: 40 },  // NOMBRE DEL CLIENTE
                    { width: 12 },  // NIT
                    { width: 12 },  // N.R.C.
                    { width: 12 },  // EXENTAS
                    { width: 12 },  // NO SUJETAS
                    { width: 12 },  // INT. GRAVADAS
                    { width: 12 },  // DEBITO FISCAL
                    { width: 12 },  // EXENTAS (terceros)
                    { width: 12 },  // NO SUJETAS (terceros)
                    { width: 12 },  // INT. GRAVADAS (terceros)
                    { width: 12 },  // DEBITO FISCAL (terceros)
                    { width: 12 },  // TOTAL
                    { width: 12 },  // IMPUESTO RETENIDO
                    { width: 12 },  // IMPUESTO PERCIBIDO
                ];
                
                // Encabezado principal
                worksheet.mergeCells('A1:S1');
                const headerRow1 = worksheet.getCell('A1');
                headerRow1.value = businessName;
                headerRow1.font = { bold: true, size: 14 };
                headerRow1.alignment = { horizontal: 'center', vertical: 'middle' };
                
                // Mes y Año
                worksheet.mergeCells('A2:C2');
                worksheet.getCell('A2').value = 'MES :';
                worksheet.getCell('A2').font = { bold: true };
                worksheet.getCell('D2').value = month.MES.toUpperCase();
                
                worksheet.mergeCells('Q2:R2');
                worksheet.getCell('Q2').value = 'N.R.C.';
                worksheet.getCell('Q2').font = { bold: true };
                worksheet.getCell('S2').value = JSON.parse(localStorage.getItem("user")).businessnrc;
                
                worksheet.mergeCells('A3:C3');
                worksheet.getCell('A3').value = 'AÑO :';
                worksheet.getCell('A3').font = { bold: true };
                worksheet.getCell('D3').value = this.search.year;
                
                worksheet.mergeCells('Q3:R3');
                worksheet.getCell('Q3').value = 'NIT';
                worksheet.getCell('Q3').font = { bold: true };
                worksheet.getCell('S3').value = JSON.parse(localStorage.getItem("user")).businessnit || '';
                
                // Título de la sección
                worksheet.mergeCells('A5:S5');
                const titleRow = worksheet.getCell('A5');
                titleRow.value = 'OPERACIONES DE VENTAS PROPIAS Y A CUENTA DE INGRESOS';
                titleRow.font = { bold: true, size: 12 };
                titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
                titleRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                // Encabezados de columnas - Parte 1
                const headerRow6 = worksheet.getRow(6);
                headerRow6.height = 40;
                
                worksheet.mergeCells('A6:A7');
                worksheet.getCell('A6').value = 'N°';
                worksheet.getCell('A6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('A6').font = { bold: true };
                
                worksheet.mergeCells('B6:B7');
                worksheet.getCell('B6').value = 'FECHA DE EMISION';
                worksheet.getCell('B6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('B6').font = { bold: true };
                
                worksheet.mergeCells('C6:C7');
                worksheet.getCell('C6').value = 'CODIGO DE GENERACION O NUMERO DE CORRELATIVO';
                worksheet.getCell('C6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('C6').font = { bold: true };
                
                worksheet.mergeCells('D6:D7');
                worksheet.getCell('D6').value = 'SELLO DE RECEPCION O NUMERO DE SERIE DEL DOCUMENTO';
                worksheet.getCell('D6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('D6').font = { bold: true };
                
                worksheet.mergeCells('E6:E7');
                worksheet.getCell('E6').value = 'NUMERO DE CONTROL O NUMERO DE RESOLUCION DEL DOCUMENTO';
                worksheet.getCell('E6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('E6').font = { bold: true };
                
                worksheet.mergeCells('F6:F7');
                worksheet.getCell('F6').value = 'NOMBRE DEL CLIENTE';
                worksheet.getCell('F6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('F6').font = { bold: true };
                
                worksheet.mergeCells('G6:G7');
                worksheet.getCell('G6').value = 'NIT';
                worksheet.getCell('G6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('G6').font = { bold: true };
                
                worksheet.mergeCells('H6:H7');
                worksheet.getCell('H6').value = 'N.R.C.';
                worksheet.getCell('H6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('H6').font = { bold: true };
                
                // Sección PROPIAS
                worksheet.mergeCells('I6:L6');
                worksheet.getCell('I6').value = 'P R O P I A S';
                worksheet.getCell('I6').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('I6').font = { bold: true };
                worksheet.getCell('I6').fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                worksheet.getCell('I7').value = 'EXENTAS';
                worksheet.getCell('I7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('I7').font = { bold: true, size: 9 };
                
                worksheet.getCell('J7').value = 'NO SUJETAS';
                worksheet.getCell('J7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('J7').font = { bold: true, size: 9 };
                
                worksheet.getCell('K7').value = 'INT. GRAVADAS';
                worksheet.getCell('K7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('K7').font = { bold: true, size: 9 };
                
                worksheet.getCell('L7').value = 'DEBITO FISCAL';
                worksheet.getCell('L7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('L7').font = { bold: true, size: 9 };
                
                // Sección A CUENTA DE TERCEROS
                worksheet.mergeCells('M6:P6');
                worksheet.getCell('M6').value = 'A CUENTA DE TERCEROS';
                worksheet.getCell('M6').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('M6').font = { bold: true };
                worksheet.getCell('M6').fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                worksheet.getCell('M7').value = 'EXENTAS';
                worksheet.getCell('M7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('M7').font = { bold: true, size: 9 };
                
                worksheet.getCell('N7').value = 'NO SUJETAS';
                worksheet.getCell('N7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('N7').font = { bold: true, size: 9 };
                
                worksheet.getCell('O7').value = 'INT. GRAVADAS';
                worksheet.getCell('O7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('O7').font = { bold: true, size: 9 };
                
                worksheet.getCell('P7').value = 'DEBITO FISCAL';
                worksheet.getCell('P7').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('P7').font = { bold: true, size: 9 };
                
                // Columnas finales
                worksheet.mergeCells('Q6:Q7');
                worksheet.getCell('Q6').value = 'TOTAL';
                worksheet.getCell('Q6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('Q6').font = { bold: true };
                
                worksheet.mergeCells('R6:R7');
                worksheet.getCell('R6').value = 'IMPUESTO RETENIDO';
                worksheet.getCell('R6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('R6').font = { bold: true };
                
                worksheet.mergeCells('S6:S7');
                worksheet.getCell('S6').value = 'IMPUESTO PERCIBIDO';
                worksheet.getCell('S6').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('S6').font = { bold: true };
                
                // Aplicar bordes a los encabezados
                for (let col = 1; col <= 19; col++) {
                    for (let row = 6; row <= 7; row++) {
                        const cell = worksheet.getCell(row, col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                        cell.fill = cell.fill || {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9D9D9' }
                        };
                    }
                }
                
                // Agregar datos
                let rowIndex = 8;
                let totales = {
                    exentas: 0,
                    noSujetas: 0,
                    gravadas: 0,
                    debitoFiscal: 0,
                    exentasTerceros: 0,
                    noSujetasTerceros: 0,
                    gravadasTerceros: 0,
                    debitoFiscalTerceros: 0,
                    impuestoTotal: 0,
                    impuestoRetenido: 0,
                    impuestoPercibido: 0
                };
                
                this.DataTable.forEach((item, index) => {
                    const row = worksheet.getRow(rowIndex);
                    
                    // Extraer NIT y NRC del campo "NIT O NRC DEL CLIENTE"
                    const nitNrcCliente = (item["NIT O NRC DEL CLIENTE"] || '').toString().trim();
                    const nit = nitNrcCliente.length === 14 ? nitNrcCliente : '';
                    const nrc = nitNrcCliente.length < 9 && nitNrcCliente.length > 0 ? nitNrcCliente : '';
                    
                    row.getCell(1).value = index + 1;
                    row.getCell(2).value = item["FECHA EMISIÓN DEL DOCUMENTO"];
                    row.getCell(3).value = item["NÚMERO DE DOCUMENTO"];
                    row.getCell(4).value = item["NUMERO DE SERIE DE DOCUMENTO"];
                    row.getCell(5).value = item["NÚMERO DE RESOLUCIÓN"];
                    row.getCell(6).value = item["NOMBRE, RAZÓN SOCIAL O DENOMINACIÓN"];
                    row.getCell(7).value = nit;
                    row.getCell(8).value = nrc;
                    
                    // Verificar si es operación a cuenta de terceros
                    const isTerceros = item["is_tercero"] == 1;
                    
                    // PROPIAS (is_tercero != 1)
                    const exentas = !isTerceros ? (parseFloat(item["VENTAS EXENTAS"]) || 0) : 0;
                    const noSujetas = !isTerceros ? (parseFloat(item["VENTAS NO SUJETAS"]) || 0) : 0;
                    const gravadas = !isTerceros ? (parseFloat(item["VENTAS GRAVADAS LOCALES"]) || 0) : 0;
                    const debitoFiscal = !isTerceros ? (parseFloat(item["DÉBITO FISCAL"]) || 0) : 0;
                    
                    row.getCell(9).value = exentas;
                    row.getCell(10).value = noSujetas;
                    row.getCell(11).value = gravadas;
                    row.getCell(12).value = debitoFiscal;
                    
                    // A CUENTA DE TERCEROS (is_terceros == 1)
                    const exentasTerceros = isTerceros ? (parseFloat(item["VENTAS EXENTAS"]) || 0) : 0;
                    const noSujetasTerceros = isTerceros ? (parseFloat(item["VENTAS NO SUJETAS"]) || 0) : 0;
                    const gravadasTerceros = parseFloat(item["VENTAS A CUENTA DE TERCEROS NO DOMICILIADOS"]) || 0;
                    const debitoFiscalTerceros = parseFloat(item["DÉBITO FISCAL POR VENTA A CUENTA DE TERCEROS"]) || 0;
                    
                    row.getCell(13).value = exentasTerceros;
                    row.getCell(14).value = noSujetasTerceros;
                    row.getCell(15).value = gravadasTerceros;
                    row.getCell(16).value = debitoFiscalTerceros;
                    
                    // FINALES - TOTAL debe incluir TODAS las columnas (exentas, no sujetas, gravadas, débito fiscal de ambos grupos)
                    const impuestoTotal = exentas + noSujetas + gravadas + debitoFiscal + exentasTerceros + noSujetasTerceros + gravadasTerceros + debitoFiscalTerceros;
                    const impuestoRetenido = parseFloat(item["RETENCIÓN IVA 1"]) || 0;
                    const impuestoPercibido = 0; // Siempre 0 según especificación
                    
                    row.getCell(17).value = impuestoTotal;
                    row.getCell(18).value = impuestoRetenido;
                    row.getCell(19).value = ''; // Siempre vacío
                    
                    // Formato de números
                    for (let col = 9; col <= 19; col++) {
                        const cell = row.getCell(col);
                        if (cell.value !== '' && cell.value !== 0) {
                            cell.numFmt = '$#,##0.00';
                            cell.alignment = { horizontal: 'right' };
                        }
                    }
                    
                    // Bordes
                    for (let col = 1; col <= 19; col++) {
                        const cell = row.getCell(col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    // Acumular totales
                    totales.exentas += exentas;
                    totales.noSujetas += noSujetas;
                    totales.gravadas += gravadas;
                    totales.debitoFiscal += debitoFiscal;
                    totales.exentasTerceros += exentasTerceros;
                    totales.noSujetasTerceros += noSujetasTerceros;
                    totales.gravadasTerceros += gravadasTerceros;
                    totales.debitoFiscalTerceros += debitoFiscalTerceros;
                    totales.impuestoTotal += impuestoTotal;
                    totales.impuestoRetenido += impuestoRetenido;
                    totales.impuestoPercibido += impuestoPercibido;
                    
                    rowIndex++;
                });
                
                // Fila de TOTALES
                const totalRow = worksheet.getRow(rowIndex);
                worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`);
                totalRow.getCell(1).value = 'TOTALES';
                totalRow.getCell(1).font = { bold: true };
                totalRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                
                totalRow.getCell(9).value = totales.exentas;
                totalRow.getCell(10).value = totales.noSujetas;
                totalRow.getCell(11).value = totales.gravadas;
                totalRow.getCell(12).value = totales.debitoFiscal;
                totalRow.getCell(13).value = totales.exentasTerceros;
                totalRow.getCell(14).value = totales.noSujetasTerceros;
                totalRow.getCell(15).value = totales.gravadasTerceros;
                totalRow.getCell(16).value = totales.debitoFiscalTerceros;
                totalRow.getCell(17).value = totales.impuestoTotal;
                totalRow.getCell(18).value = totales.impuestoRetenido;
                totalRow.getCell(19).value = ''; // Siempre vacío
                
                // Formato fila totales
                for (let col = 9; col <= 19; col++) {
                    const cell = totalRow.getCell(col);
                    cell.numFmt = '$#,##0.00';
                    cell.font = { bold: true };
                    cell.alignment = { horizontal: 'right' };
                }
                
                // Bordes fila totales
                for (let col = 1; col <= 19; col++) {
                    const cell = totalRow.getCell(col);
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFD9D9D9' }
                    };
                }
                
                rowIndex += 2;
                
                // Sección RESUMEN DE OPERACIONES
                const resumenHeaderRow = worksheet.getRow(rowIndex);
                
                // Título del resumen en A-H
                worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`);
                const resumenRow = resumenHeaderRow.getCell(1);
                resumenRow.value = 'R E S U M E N   D E   O P E R A C I O N E S';
                resumenRow.font = { bold: true, size: 12 };
                resumenRow.alignment = { horizontal: 'center', vertical: 'middle' };
                resumenRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                // Headers PROPIAS y A CUENTA DE TERCEROS en la misma fila
                worksheet.mergeCells(`I${rowIndex}:J${rowIndex}`);
                resumenHeaderRow.getCell(9).value = 'PROPIAS';
                resumenHeaderRow.getCell(9).alignment = { horizontal: 'center', vertical: 'middle' };
                resumenHeaderRow.getCell(9).font = { bold: true };
                resumenHeaderRow.getCell(9).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                worksheet.mergeCells(`K${rowIndex}:L${rowIndex}`);
                resumenHeaderRow.getCell(11).value = 'A CUENTA DE TERCEROS';
                resumenHeaderRow.getCell(11).alignment = { horizontal: 'center', vertical: 'middle' };
                resumenHeaderRow.getCell(11).font = { bold: true };
                resumenHeaderRow.getCell(11).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                // Agregar bordes a la fila del título del resumen
                for (let col = 1; col <= 12; col++) {
                    resumenHeaderRow.getCell(col).border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                }
                
                rowIndex++;
                
                // Subheaders (VALOR NETO y DEBITO FISCAL)
                const resumenHeaders = worksheet.getRow(rowIndex);
                worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`);
                resumenHeaders.getCell(1).value = '';
                
                // Subheaders resumen
                const subHeadersRow = resumenHeaders;
                subHeadersRow.getCell(9).value = 'VALOR NETO';
                subHeadersRow.getCell(10).value = 'DEBITO FISCAL';
                subHeadersRow.getCell(11).value = 'VALOR NETO';
                subHeadersRow.getCell(12).value = 'DEBITO FISCAL';
                
                for (let col = 9; col <= 12; col++) {
                    subHeadersRow.getCell(col).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    subHeadersRow.getCell(col).font = { bold: true, size: 9 };
                    subHeadersRow.getCell(col).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFD9D9D9' }
                    };
                }
                
                // Agregar bordes a las columnas A-H de los encabezados
                for (let col = 1; col <= 8; col++) {
                    resumenHeaders.getCell(col).border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    subHeadersRow.getCell(col).border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                }
                
                // Agregar bordes a las columnas I-L de los encabezados
                for (let col = 9; col <= 12; col++) {
                    resumenHeaders.getCell(col).border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    subHeadersRow.getCell(col).border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                }
                
                rowIndex++;
                
                // Calcular datos del resumen (Consumidores Finales)
                const gravadas2 = this.DataTable2.reduce((acc, item) => acc + parseFloat(item["VentasGravadasLocales"] || 0), 0);
                const nosujetas2 = this.DataTable2.reduce((acc, item) => acc + parseFloat(item["VentasNoSujetas"] || 0), 0);
                const exportaciones2 = this.DataTable2.reduce((acc, item) => acc + parseFloat(item["Exportaciones"] || 0), 0);
                const exentas2 = this.DataTable2.reduce((acc, item) => acc + parseFloat(item["VentasExentas"] || 0), 0);
                const ventas_terceros2 = this.DataTable2.reduce((acc, item) => acc + parseFloat(item["VentaACuentaDeTercerosNoDomiciliados"] || 0), 0);
                
                const gravadas_terceros2 = parseFloat(ventas_terceros2) / 1.13;
                const debito_terceros2 = gravadas_terceros2 * 0.13;
                const gravadasNetas2 = parseFloat(gravadas2) / 1.13;
                const debitoFiscal2 = gravadasNetas2 * 0.13;
                
                // Calcular totales del resumen
                const totalGravadasNetas = totales.gravadas + gravadasNetas2;
                const totalDebitoFiscalResumen = totales.debitoFiscal + debitoFiscal2;
                const totalGravadasTerceros = totales.gravadasTerceros + gravadas_terceros2;
                const totalDebitoTerceros = totales.debitoFiscalTerceros + debito_terceros2;
                
                // Separar exentas/no sujetas por grupo
                const totalExentasNoSujetasPropias = totales.exentas + totales.noSujetas + exentas2 + nosujetas2;
                const totalExentasNoSujetasTerceros = totales.exentasTerceros + totales.noSujetasTerceros;
                
                // TOTAL VENTAS separado por columnas PROPIAS y TERCEROS
                const totalVentasValorNeto = 
                    // TOTAL OPERACIONES INTERNAS GRAVADAS PROPIAS (VALOR NETO)
                    totalGravadasNetas +
                    // TOTAL OPERACIONES INTERNAS EXENTAS O NO SUJETAS PROPIAS (VALOR NETO)
                    totalExentasNoSujetasPropias +
                    // EXPORTACIONES
                    exportaciones2;
                
                const totalVentasDebitoFiscal = 
                    // TOTAL OPERACIONES INTERNAS GRAVADAS PROPIAS (DEBITO FISCAL)
                    totalDebitoFiscalResumen +
                    // TOTAL OPERACIONES INTERNAS EXENTAS O NO SUJETAS PROPIAS (DEBITO FISCAL = 0)
                    0 +
                    // EXPORTACIONES (DEBITO FISCAL = 0)
                    0;
                
                // TOTAL VENTAS A CUENTA DE TERCEROS
                const totalVentasValorNetoTerceros = 
                    // TOTAL OPERACIONES INTERNAS GRAVADAS TERCEROS (VALOR NETO)
                    totalGravadasTerceros +
                    // TOTAL OPERACIONES INTERNAS EXENTAS O NO SUJETAS TERCEROS (VALOR NETO)
                    totalExentasNoSujetasTerceros;
                
                const totalVentasDebitoFiscalTerceros = 
                    // TOTAL OPERACIONES INTERNAS GRAVADAS TERCEROS (DEBITO FISCAL)
                    totalDebitoTerceros +
                    // TOTAL OPERACIONES INTERNAS EXENTAS O NO SUJETAS TERCEROS (DEBITO FISCAL = 0)
                    0;
                
                // Filas del resumen
                const resumenData = [
                    ['VENTAS NETAS INTERNAS GRAVADAS A CONTRIBUYENTES', '', '', '', '', '', '', '', totales.gravadas, totales.debitoFiscal, totales.gravadasTerceros, totales.debitoFiscalTerceros],
                    ['VENTAS NETAS INTERNAS GRAVADAS A CON SUMIDORES', '', '', '', '', '', '', '', gravadasNetas2, debitoFiscal2, gravadas_terceros2, debito_terceros2],
                    ['TOTAL OPERACIONES INTERNAS GRAVADAS', '', '', '', '', '', '', '', totalGravadasNetas, totalDebitoFiscalResumen, totalGravadasTerceros, totalDebitoTerceros],
                    ['', '', '', '', '', '', '', '', '', '', '', ''],
                    ['VENTAS NETAS INTERNAS EXENTAS O NO SUJETAS A CONTRIBUYENTES', '', '', '', '', '', '', '', totales.exentas + totales.noSujetas, 0, totales.exentasTerceros + totales.noSujetasTerceros, 0],
                    ['VENTAS NETAS INTERNAS EXENTAS O NO SUJETAS A CON SUMIDORES', '', '', '', '', '', '', '', exentas2 + nosujetas2, 0, '', ''],
                    ['TOTAL OPERACIONES INTERNAS EXENTAS O NO SUJETAS', '', '', '', '', '', '', '', totalExentasNoSujetasPropias, 0, totalExentasNoSujetasTerceros, 0],
                    ['', '', '', '', '', '', '', '', '', '', '', ''],
                    ['EXPORTACIONES SEGÚN FACTURAS DE EXPORTACION', '', '', '', '', '', '', '', exportaciones2, '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', ''],
                    ['TOTAL VENTAS', '', '', '', '', '', '', '', totalVentasValorNeto, totalVentasDebitoFiscal, totalVentasValorNetoTerceros, totalVentasDebitoFiscalTerceros],
                ];
                
                resumenData.forEach((dataRow) => {
                    const row = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`);
                    row.getCell(1).value = dataRow[0];
                    row.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                    row.getCell(1).font = { size: 9 };
                    
                    // Columnas I-L (posiciones 9-12)
                    for (let i = 0; i < 4; i++) {
                        const cell = row.getCell(9 + i);
                        const value = dataRow[8 + i];
                        if (value !== '' && value !== undefined) {
                            cell.value = value;
                            cell.numFmt = '$#,##0.00';
                            cell.alignment = { horizontal: 'right' };
                        }
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    // Bordes para las primeras columnas
                    for (let col = 1; col <= 8; col++) {
                        const cell = row.getCell(col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    rowIndex++;
                });
                
                // Generar y descargar el archivo
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `Reporte de ventas (Contribuyentes) - ${month.MES} de ${this.search.year}.xlsx`);
                
                this.showAlert("success", "Éxito", "El archivo Excel se ha generado correctamente.");
        },
        async generateExcelConsumidores(workbook, worksheet, businessName, month) {
                // Obtener datos del nuevo endpoint
                try {
                    const params = {
                        month: this.search.month,
                        year: this.search.year,
                        dataType: this.dataType,
                        ID_Branch: this.allBranch ? 'all' : undefined
                    };

                    const response = await this.$API.accountingreports.getFinalConsumerExcelData(params);
                    
                    if (!response.data || !response.data.success) {
                        throw new Error('No se pudieron obtener los datos');
                    }

                    const datosConsumidores = response.data.data || [];

                    if (datosConsumidores.length === 0) {
                        this.showAlert("warning", "Advertencia", "No hay datos disponibles para generar el Excel.");
                        return;
                    }

                    // Configurar el ancho de las columnas
                    worksheet.columns = [
                        { width: 4 },   // Col A (1): N° | Key: index + 1 | Condición: siempre
                        { width: 12 },  // Col B (2): FECHA DE EMISION | Key: item.InvoiceDate | Condición: siempre
                        { width: 20 },  // Col C (3): NUMERO CORRELATIVO O NUMERO DE REIMPRESO | Key: item.ID_Invoice || item.CodigoGeneracion | Condición: siempre
                        { width: 20 },  // Col D (4): SELLO DE RECEPCION O NUMERO DE SERIE DEL DOCUMENTO | Key: item.SelloRecepcion | Condición: siempre
                        { width: 20 },  // Col E (5): NUMERO DE CONTROL O NUMERO DE RESOLUCION DEL DOCUMENTO | Key: item.NumeroControl | Condición: siempre
                        { width: 40 },  // Col F (6): NOMBRE DEL CLIENTE | Key: item.LegalName | Condición: siempre
                        { width: 12 },  // Col G (7): EXENTAS (Propias) | Key: item.InvoiceTotalExenta | Condición: !isTerceros (IsVentaTercero != 1)
                        { width: 12 },  // Col H (8): NO SUJETAS (Propias) | Key: item.InvoiceTotalNoSuj | Condición: !isTerceros (IsVentaTercero != 1)
                        { width: 12 },  // Col I (9): EXPORTACIONES (Propias) | Key: item.Exportacion | Condición: !isTerceros && isExportacion (IsVentaTercero != 1 && isExportacion == 1)
                        { width: 12 },  // Col J (10): INT. GRAVADAS (Propias) | Key: item.InvoiceTotalGravada | Condición: !isTerceros && !isExportacion (IsVentaTercero != 1 && isExportacion != 1)
                        { width: 12 },  // Col K (11): DEBITO FISCAL (Propias) | Key: item.Iva | Condición: !isTerceros (IsVentaTercero != 1)
                        { width: 12 },  // Col L (12): EXENTAS (terceros) | Key: item.InvoiceTotalExenta | Condición: isTerceros (IsVentaTercero == 1)
                        { width: 12 },  // Col M (13): NO SUJETA (terceros) | Key: item.InvoiceTotalNoSuj | Condición: isTerceros (IsVentaTercero == 1)
                        { width: 12 },  // Col N (14): INT. GRAVADAS (terceros) | Key: item.VentaTerceros | Condición: isTerceros (IsVentaTercero == 1)
                        { width: 12 },  // Col O (15): DEBITO FISCAL (terceros) | Key: item.IvaVentaTerceros | Condición: isTerceros (IsVentaTercero == 1)
                        { width: 12 },  // Col P (16): TOTAL | Cálculo: debitoFiscal + debitoFiscalTerceros | Condición: siempre
                        { width: 12 },  // Col Q (17): MONTO A RETENCION | Key: item.InvoiceIvaRete1 | Condición: siempre
                        { width: 12 },  // Col R (18): IMPUESTO PERCIBIDO | Key: item.InvoiceIvaPerce1 | Condición: siempre
                    ];
                    
                    // Encabezado principal
                    worksheet.mergeCells('A1:R1');
                    const headerRow1 = worksheet.getCell('A1');
                    headerRow1.value = businessName;
                    headerRow1.font = { bold: true, size: 14 };
                    headerRow1.alignment = { horizontal: 'center', vertical: 'middle' };
                    
                    // Subtítulo
                    worksheet.mergeCells('A2:R2');
                    const headerRow2 = worksheet.getCell('A2');
                    headerRow2.value = 'LIBRO O REGISTRO DE OPERACIONES DE VENTAS A CONSUMIDORES FINALES';
                    headerRow2.font = { bold: true, size: 11 };
                    headerRow2.alignment = { horizontal: 'center', vertical: 'middle' };
                
                // Mes, Año, NRC, NIT
                worksheet.mergeCells('A4:B4');
                worksheet.getCell('A4').value = 'MES :';
                worksheet.getCell('A4').font = { bold: true };
                worksheet.getCell('C4').value = month.MES.toUpperCase();
                
                worksheet.mergeCells('O4:P4');
                worksheet.getCell('O4').value = 'N.R.C.';
                worksheet.getCell('O4').font = { bold: true };
                worksheet.getCell('R4').value = JSON.parse(localStorage.getItem("user")).businessnrc;
                
                worksheet.mergeCells('A5:B5');
                worksheet.getCell('A5').value = 'AÑO :';
                worksheet.getCell('A5').font = { bold: true };
                worksheet.getCell('C5').value = this.search.year;
                
                worksheet.mergeCells('O5:P5');
                worksheet.getCell('O5').value = 'NIT';
                worksheet.getCell('O5').font = { bold: true };
                worksheet.getCell('R5').value = JSON.parse(localStorage.getItem("user")).businessnit || '';
                
                // Título de la sección
                worksheet.mergeCells('A7:R7');
                const titleRow = worksheet.getCell('A7');
                titleRow.value = 'OPERACIONES DE VENTAS PROPIAS Y  A  CUENTA DE TERCEROS';
                titleRow.font = { bold: true, size: 11 };
                titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
                titleRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                // Encabezados de columnas
                const headerRow9 = worksheet.getRow(9);
                headerRow9.height = 40;
                
                // Columnas simples (A-F)
                worksheet.mergeCells('A9:A10');
                worksheet.getCell('A9').value = 'N°';
                worksheet.getCell('A9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('A9').font = { bold: true };
                
                worksheet.mergeCells('B9:B10');
                worksheet.getCell('B9').value = 'FECHA DE EMISION';
                worksheet.getCell('B9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('B9').font = { bold: true };
                
                worksheet.mergeCells('C9:C10');
                worksheet.getCell('C9').value = 'NUMERO CORRELATIVO O NUMERO DE REIMPRESO';
                worksheet.getCell('C9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('C9').font = { bold: true };
                
                worksheet.mergeCells('D9:D10');
                worksheet.getCell('D9').value = 'SELLO DE RECEPCION O NUMERO DE SERIE DEL DOCUMENTO';
                worksheet.getCell('D9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('D9').font = { bold: true };
                
                worksheet.mergeCells('E9:E10');
                worksheet.getCell('E9').value = 'NUMERO DE CONTROL O NUMERO DE RESOLUCION DEL DOCUMENTO';
                worksheet.getCell('E9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('E9').font = { bold: true };
                
                worksheet.mergeCells('F9:F10');
                worksheet.getCell('F9').value = 'NOMBRE DEL CLIENTE';
                worksheet.getCell('F9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('F9').font = { bold: true };
                
                // Sección PROPIAS (G-K) - 5 columnas
                worksheet.mergeCells('G9:K9');
                worksheet.getCell('G9').value = 'P R O P I A S';
                worksheet.getCell('G9').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('G9').font = { bold: true };
                worksheet.getCell('G9').fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                worksheet.getCell('G10').value = 'EXENTAS';
                worksheet.getCell('G10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('G10').font = { bold: true, size: 9 };
                
                worksheet.getCell('H10').value = 'NO SUJETAS';
                worksheet.getCell('H10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('H10').font = { bold: true, size: 9 };
                
                worksheet.getCell('I10').value = 'EXPORTACIONES';
                worksheet.getCell('I10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('I10').font = { bold: true, size: 9 };
                
                worksheet.getCell('J10').value = 'INT. GRAVADAS';
                worksheet.getCell('J10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('J10').font = { bold: true, size: 9 };
                
                worksheet.getCell('K10').value = 'DEBITO FISCAL';
                worksheet.getCell('K10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('K10').font = { bold: true, size: 9 };
                
                // Sección A CUENTA DE TERCEROS (L-O) - 4 columnas
                worksheet.mergeCells('L9:O9');
                worksheet.getCell('L9').value = 'A   C U E N T A   D E   T E R C E R O S';
                worksheet.getCell('L9').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('L9').font = { bold: true };
                worksheet.getCell('L9').fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB8CCE4' }
                };
                
                worksheet.getCell('L10').value = 'EXENTAS';
                worksheet.getCell('L10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('L10').font = { bold: true, size: 9 };
                
                worksheet.getCell('M10').value = 'NO SUJETA';
                worksheet.getCell('M10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('M10').font = { bold: true, size: 9 };
                
                worksheet.getCell('N10').value = 'INT. GRAVADAS';
                worksheet.getCell('N10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('N10').font = { bold: true, size: 9 };
                
                worksheet.getCell('O10').value = 'DEBITO FISCAL';
                worksheet.getCell('O10').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('O10').font = { bold: true, size: 9 };
                
                // Columnas finales (P-R)
                worksheet.mergeCells('P9:P10');
                worksheet.getCell('P9').value = 'TOTAL';
                worksheet.getCell('P9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('P9').font = { bold: true };
                
                worksheet.mergeCells('Q9:Q10');
                worksheet.getCell('Q9').value = 'MONTO A RETENCION';
                worksheet.getCell('Q9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('Q9').font = { bold: true };
                
                worksheet.mergeCells('R9:R10');
                worksheet.getCell('R9').value = 'IMPUESTO PERCIBIDO';
                worksheet.getCell('R9').alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                worksheet.getCell('R9').font = { bold: true };
                
                // Aplicar bordes y colores a los encabezados
                for (let col = 1; col <= 18; col++) {
                    for (let row = 9; row <= 10; row++) {
                        const cell = worksheet.getCell(row, col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                        cell.fill = cell.fill || {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9D9D9' }
                        };
                    }
                }
                
                    // Agregar datos
                    let rowIndex = 11;
                    let totales = {
                        exentas: 0,
                        noSujetas: 0,
                        exportaciones: 0,
                        gravadas: 0,
                        debitoFiscal: 0,
                        exentasTerceros: 0,
                        noSujetasTerceros: 0,
                        gravadasTerceros: 0,
                        debitoFiscalTerceros: 0,
                        impuestoTotal: 0,
                        impuestoRetenido: 0,
                        impuestoPercibido: 0
                    };
                    
                    datosConsumidores.forEach((item, index) => {
                        const row = worksheet.getRow(rowIndex);
                        
                        row.getCell(1).value = index + 1;
                        row.getCell(2).value = item.InvoiceDate || '';
                        
                        // Número correlativo - ID de factura o código de generación
                        row.getCell(3).value = item.ID_Invoice || item.CodigoGeneracion || '';
                        
                        // Sello de recepción
                        row.getCell(4).value = item.SelloRecepcion || '';
                        
                        // Número de control
                        row.getCell(5).value = item.NumeroControl || '';
                        
                        // Nombre del cliente
                        row.getCell(6).value = item.LegalName || '';
                        
                        // Verificar si es operación a cuenta de terceros
                        const isTerceros = item.IsVentaTercero == 1;
                        const isExportacion = item.isExportacion == 1;
                        
                        // PROPIAS (IsVentaTercero != 1)
                        const exentas = !isTerceros ? (parseFloat(item.InvoiceTotalExenta) || 0) : 0;
                        const noSujetas = !isTerceros ? (parseFloat(item.InvoiceTotalNoSuj) || 0) : 0;
                        const exportaciones = !isTerceros && isExportacion ? (parseFloat(item.Exportacion) || 0) : 0;
                        const gravadas = !isTerceros && !isExportacion ? (parseFloat(item.InvoiceTotalGravada) || 0) : 0;
                        const debitoFiscal = !isTerceros ? (parseFloat(item.Iva) || 0) : 0;
                        
                        row.getCell(7).value = exentas;
                        row.getCell(8).value = noSujetas;
                        row.getCell(9).value = exportaciones;
                        row.getCell(10).value = gravadas;
                        row.getCell(11).value = debitoFiscal;
                        
                        // A CUENTA DE TERCEROS (IsVentaTercero == 1)
                        const exentasTerceros = isTerceros ? (parseFloat(item.InvoiceTotalExenta) || 0) : 0;
                        const noSujetasTerceros = isTerceros ? (parseFloat(item.InvoiceTotalNoSuj) || 0) : 0;
                        const gravadasTerceros = isTerceros ? (parseFloat(item.VentaTerceros) || 0) : 0;
                        const debitoFiscalTerceros = isTerceros ? (parseFloat(item.IvaVentaTerceros) || 0) : 0;
                        
                        row.getCell(12).value = exentasTerceros;
                        row.getCell(13).value = noSujetasTerceros;
                        row.getCell(14).value = gravadasTerceros;
                        row.getCell(15).value = debitoFiscalTerceros;
                        
                        // FINALES
                        const impuestoTotal = debitoFiscal + debitoFiscalTerceros;
                        const impuestoRetenido = parseFloat(item.InvoiceIvaRete1) || 0;
                        const impuestoPercibido = parseFloat(item.InvoiceIvaPerce1) || 0;
                        
                        row.getCell(16).value = impuestoTotal;
                        row.getCell(17).value = impuestoRetenido;
                        row.getCell(18).value = impuestoPercibido;
                        
                        // Formato de números
                        for (let col = 7; col <= 18; col++) {
                            const cell = row.getCell(col);
                            if (cell.value !== '' && cell.value !== 0) {
                                cell.numFmt = '$#,##0.00';
                                cell.alignment = { horizontal: 'right' };
                            }
                        }
                        
                        // Bordes
                        for (let col = 1; col <= 18; col++) {
                            const cell = row.getCell(col);
                            cell.border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            };
                        }
                        
                        // Acumular totales
                        totales.exentas += exentas;
                        totales.noSujetas += noSujetas;
                        totales.exportaciones += exportaciones;
                        totales.gravadas += gravadas;
                        totales.debitoFiscal += debitoFiscal;
                        totales.exentasTerceros += exentasTerceros;
                        totales.noSujetasTerceros += noSujetasTerceros;
                        totales.gravadasTerceros += gravadasTerceros;
                        totales.debitoFiscalTerceros += debitoFiscalTerceros;
                        totales.impuestoTotal += impuestoTotal;
                        totales.impuestoRetenido += impuestoRetenido;
                        totales.impuestoPercibido += impuestoPercibido;
                        
                        rowIndex++;
                    });
                
                    // Fila de TOTALES
                    const totalRow = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`A${rowIndex}:F${rowIndex}`);
                    totalRow.getCell(1).value = 'TOTALES';
                    totalRow.getCell(1).font = { bold: true };
                    totalRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                    
                    totalRow.getCell(7).value = totales.exentas;
                    totalRow.getCell(8).value = totales.noSujetas;
                    totalRow.getCell(9).value = totales.exportaciones;
                    totalRow.getCell(10).value = totales.gravadas;
                    totalRow.getCell(11).value = totales.debitoFiscal;
                    totalRow.getCell(12).value = totales.exentasTerceros;
                    totalRow.getCell(13).value = totales.noSujetasTerceros;
                    totalRow.getCell(14).value = totales.gravadasTerceros;
                    totalRow.getCell(15).value = totales.debitoFiscalTerceros;
                    totalRow.getCell(16).value = totales.impuestoTotal;
                    totalRow.getCell(17).value = totales.impuestoRetenido;
                    totalRow.getCell(18).value = totales.impuestoPercibido;
                    
                    // Formato fila totales
                    for (let col = 7; col <= 18; col++) {
                        const cell = totalRow.getCell(col);
                        cell.numFmt = '$#,##0.00';
                        cell.font = { bold: true };
                        cell.alignment = { horizontal: 'right' };
                    }
                    
                    // Bordes fila totales
                    for (let col = 1; col <= 18; col++) {
                        const cell = totalRow.getCell(col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFD9D9D9' }
                        };
                    }
                    
                    // Sección de TOTALES CALCULADOS
                    rowIndex += 3;
                    
                    // Calcular los totales
                    const ventaGravadaTotal = totales.gravadas + totales.gravadasTerceros;
                    const ventaGravadaNeta = ventaGravadaTotal / 1.13;
                    const ivaCalculado = ventaGravadaNeta * 0.13;
                    const retencion = totales.impuestoRetenido;
                    const totalFinal = ventaGravadaTotal;
                    
                    // Fila: Venta gravada Total
                    const rowVentaTotal = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`D${rowIndex}:F${rowIndex}`);
                    rowVentaTotal.getCell(4).value = 'Venta gravada Total';
                    rowVentaTotal.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
                    rowVentaTotal.getCell(4).font = { bold: true };
                    rowVentaTotal.getCell(7).value = ventaGravadaTotal;
                    rowVentaTotal.getCell(7).numFmt = '$#,##0.00';
                    rowVentaTotal.getCell(7).alignment = { horizontal: 'right' };
                    rowIndex++;
                    
                    // Fila: Venta gravada Total /1.13
                    const rowVentaNeta = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`D${rowIndex}:F${rowIndex}`);
                    rowVentaNeta.getCell(4).value = 'Venta gravada Total /1.13';
                    rowVentaNeta.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
                    rowVentaNeta.getCell(4).font = { bold: true };
                    rowVentaNeta.getCell(7).value = ventaGravadaNeta;
                    rowVentaNeta.getCell(7).numFmt = '$#,##0.00';
                    rowVentaNeta.getCell(7).alignment = { horizontal: 'right' };
                    rowIndex++;
                    
                    // Fila: 13 % IVA
                    const rowIVA = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`D${rowIndex}:F${rowIndex}`);
                    rowIVA.getCell(4).value = '13 % IVA';
                    rowIVA.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
                    rowIVA.getCell(4).font = { bold: true };
                    rowIVA.getCell(7).value = ivaCalculado;
                    rowIVA.getCell(7).numFmt = '$#,##0.00';
                    rowIVA.getCell(7).alignment = { horizontal: 'right' };
                    rowIndex++;
                    
                    // Fila: Retención
                    const rowRetencion = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`D${rowIndex}:F${rowIndex}`);
                    rowRetencion.getCell(4).value = 'Retención';
                    rowRetencion.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
                    rowRetencion.getCell(4).font = { bold: true };
                    rowRetencion.getCell(7).value = retencion;
                    rowRetencion.getCell(7).numFmt = '$#,##0.00';
                    rowRetencion.getCell(7).alignment = { horizontal: 'right' };
                    rowIndex++;
                    
                    // Fila: TOTAL
                    const rowTotalFinal = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`D${rowIndex}:F${rowIndex}`);
                    rowTotalFinal.getCell(4).value = 'TOTAL';
                    rowTotalFinal.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
                    rowTotalFinal.getCell(4).font = { bold: true };
                    rowTotalFinal.getCell(7).value = totalFinal;
                    rowTotalFinal.getCell(7).numFmt = '$#,##0.00';
                    rowTotalFinal.getCell(7).alignment = { horizontal: 'right' };
                    rowTotalFinal.getCell(7).font = { bold: true };
                    rowIndex++;
                    
                    // Sección de FIRMAS
                    rowIndex += 3;
                    
                    // Línea para firma del Contador
                    const rowFirmaContador = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`A${rowIndex}:D${rowIndex}`);
                    rowFirmaContador.getCell(1).value = '';
                    rowFirmaContador.getCell(1).border = {
                        top: { style: 'thin' }
                    };
                    rowIndex++;
                    
                    const rowTextoContador = worksheet.getRow(rowIndex);
                    worksheet.mergeCells(`A${rowIndex}:D${rowIndex}`);
                    rowTextoContador.getCell(1).value = 'Contador';
                    rowTextoContador.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                    rowTextoContador.getCell(1).font = { bold: true };
                    
                    // Generar y descargar el archivo
                    const buffer = await workbook.xlsx.writeBuffer();
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, `Reporte de ventas (Consumidores Finales) - ${month.MES} de ${this.search.year}.xlsx`);
                    
                    this.showAlert("success", "Éxito", "El archivo Excel se ha generado correctamente.");

                } catch (error) {
                    console.error('Error al obtener datos de consumidores finales:', error);
                    this.showAlert("danger", "Error", "No se pudieron obtener los datos para generar el Excel.");
                }
            this.monthList = (await this.$API.accountingreports.getSalesDateMonths(this.search)).months
            this.search.month = this.monthList[this.monthList.length - 1].monthIndex;
        },
        filterHandler(data) {
            if (this.reportType === '1') {
                this.DataTable = data.data;
            } else {
                this.DataTable2 = data.data;
            }
        },
        getReportSales() {
            if (this.search.month == null || this.search.year == null) {
                return;
            }

            this.loading = true;
            this.$API.accountingreports.getSalesByDate({ ...this.search, reportType: this.reportType, dataType: this.dataType, allBranch: this.allBranch }).then((res) => {
                const columnsToModToFloat = [
                    'RETENCIÓN IVA 1', 
                    'IvaRetencion',
                    'TOTAL VENTAS', 
                    'Exportaciones', 
                    'ExportacionesDentroDelAreaCentroamericana', 
                    'ExportacionesFueraDelAreaCentroamericana', 
                    'VentasGravadasLocales',
                    'VENTAS GRAVADAS LOCALES',
                    'DÉBITO FISCAL'
                ];
                if (this.reportType === '1') {
                    res.data.data1.forEach(element => {
                        columnsToModToFloat.forEach(item => {
                            if (!isNaN(element?.[item])) {
                                element[item] = parseFloat(element[item]).toFixed(2);
                            }
                        });
                    });
                    res.data.data2.forEach(element => {
                        columnsToModToFloat.forEach(item => {
                            if (!isNaN(element?.[item])) {
                                element[item] = parseFloat(element[item]).toFixed(2);
                            }
                        });
                    });
                    this.DataTable = res.data.data1;
                    this.DataTable2 = res.data.data2;
                    this.invalidRowsCount = this.countInvalidRows(this.DataTable, this.columnsTaxPayer);
                } else {
                    console.log(res)
                    res.data.forEach(element => {
                        columnsToModToFloat.forEach(item => {
                            if (!isNaN(element?.[item])) {
                                element[item] = parseFloat(element[item]).toFixed(2);
                            }
                        });
                    })
                    this.DataTable2 = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                this.loading = false;
                this.showAlert("danger", "Error", err);
            });
        },
        printconfig() {
            this.showPrint = true;
            this.print.show = false;
            const month = this.monthList.find((element) => element.monthIndex == this.search.month);

            this.print.header.month = month.MES;
            this.print.header.year = this.search.year;
            this.print.header.reportType = this.reportType;
            this.print.data.body = this.reportType === '1' ? this.DataTable : this.DataTable2;
            console.log(this.print.data.body);
            //this.reloadPrint++;
            this.print.show = true;

            this.windowsList.push({
                component: SubPrint,
                props: {
                    print: this.print,
                },
                key: new Date().getTime(),
            });

        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;


        },
        onExporting(e) {
            let array = null;
            if (this.reportType === '1') {
                array = ['Exportaciones', 'Ventas Gravadas', 'Débito Fiscal', 'Venta a Cuenta de Terceros', 'Débito Fiscal a Cuenta de Terceros',
                    'No Sujeta', 'Exenta', 'Retencion', 'Impuesto Percibido', 'Ventas Totales'
                ];
            } else {
                array = ['Ventas Exentas', 'Ventas Gravadas', 'Exportaciones', 'Venta Total'];
            }
            console.log(array);
            printToExcel(e, "Reporte de ventas", array);
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        openEditDialog(rowData) {
            this.editDialog.data = { ...rowData };
            this.editDialog.originalData = rowData;
            this.editDialog.show = true;
        },
        closeEditDialog() {
            this.editDialog.show = false;
            this.editDialog.data = {};
            this.editDialog.originalData = {};
        },
        isFormValid() {
            const requiredFields = ['TIPO DE INGRESO'];
            return requiredFields.every(field => {
                const value = this.editDialog.data[field];
                return !this.isEmptyOrInvalid(value);
            });
        },
        async saveEditedData() {
            if (!this.isFormValid()) {
                this.showAlert("warning", "Campos incompletos", "Por favor complete el campo requerido.");
                return;
            }

            try {
                this.loading = true;

                const customerId = this.editDialog.originalData['ID_Customer'];
                
                // Validar que el ID_Customer esté presente
                if (!customerId) {
                    this.showAlert("danger", "Error", "No se pudo identificar al cliente para actualizar.");
                    return;
                }
                
                await this.$API.customers.updateCustomerBusinessSector({
                    customerId: customerId,
                    businessSector: this.editDialog.data['TIPO DE INGRESO']
                });

                // Recargar los datos de la tabla para actualizar todos los registros del cliente
                await this.getReportSales();

                this.showAlert("success", "Éxito", "El tipo de ingreso se ha actualizado correctamente.");
                this.closeEditDialog();
            } catch (error) {
                this.showAlert("danger", "Error", error.response?.data?.message || "Error al actualizar el tipo de ingreso");
            } finally {
                this.loading = false;
            }
        },
        getTipoIngresoLabel(codigo) {
            if (!codigo) return 'No especificado';
            const tipo = this.tipoIngresoClientes.find(t => t.Codigo === String(codigo));
            return tipo ? tipo.Valores : codigo;
        },
        hasEmptyRequiredFields(rowData) {
            // Solo verificar cuando es printType='1' y reportType='1'
            if (this.printType !== '1' || this.reportType !== '1') return false;
            
            const requiredFields = this.columnsTaxPayer
                .filter(col => col.required && col.dataField)
                .map(col => col.dataField);

            return requiredFields.some(field => {
                const value = rowData[field];
                return this.isEmptyOrInvalid(value);
            });
        },
    },

}
</script>

<style scoped>
:deep(.errorRow){
    background-color: #fff3cd !important;
  color: #856404 !important;
  font-weight: bold;
}

.bar {
    width: 100%;
    background-color: rgb(60, 60, 60) !important;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-radius: 15px !important;
    margin-top: 1rem !important;
}

.btn-add {
    background-color: #3498DB !important;
    color: white;
}

.btnsave {
    background-color: #00A178 !important;
    color: white;
}

.btnclean {
    background-color: #F29D35 !important;
    color: white;
}

.btndelete {
    background-color: #E3191E !important;
    color: white;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .right-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .left-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .center-column {
    text-align: center !important;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .right-column {
    text-align: right !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .left-column {
    text-align: left !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .center-column {
    text-align: center !important;
    font-size: 10px;
}
</style>
